{
  "customer-request-online-booking-dialog": {
    "buttons": {
      "submit": "EINREICHEN"
    },
    "text": {
      "title": "Online-Buchungsanfrage",
      "email": "Ihre E-Mail",
      "hint": "Der Salon bietet noch keine Online-Terminbuchung an. Hinterlassen Sie Ihre E-Mail und wir werden Sie benachrichtigen, wenn die Online-Terminbuchung für den Salon in Zukunft aktiviert wird",
      "request-sent-success": "Ihre Anfrage wurde erfolgreich gesendet!"
    }
  }
}
